export default "__VITE_ASSET__15d1f843__"